import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,  imports: [MatProgressSpinnerModule, CommonModule],
})
export class SpinnerComponent {
  @Input() display = false;
  @Input() class!: string;
  @Input() diameter = 60; // Reduced from 100 to 60
  @Input() messageToDisplay = '';
}
